document.addEventListener("DOMContentLoaded", function () {
  /**
   * Handle Flavor Changing
   */
  // Get the current Flavor
  const currentFlavor = document.querySelector(
    '.variant-input[data-index="option1"] input:checked'
  );

  // Display the current Flavor
  const flavourDisplay = document.getElementById("flavour-display");
  flavourDisplay.textContent = currentFlavor.value;

  const FlavorSelect = document.querySelectorAll(
    '.variant-input[data-index="option1"] input'
  );

  FlavorSelect.forEach(function (input) {
    input.addEventListener("click", function () {
      flavourDisplay.textContent = input.value;
    });
  });

  /**
   * Handle Flavor Color changing
   */
  const flavorButton = document.querySelectorAll('input[data-index="option1"]');
  flavorButton.forEach((e) => {
    e.addEventListener("click", (input) => {
      const color = input.target.getAttribute("data-color-metafield");
      flavourDisplay.style.color = color;
    });
  });

  const shippingText = document.querySelector(".shipping-text span");

  if (shippingText) {
    const today = new Date();
    const deliveryDate = new Date(today);
    deliveryDate.setDate(deliveryDate.getDate() + 5);
    const options = {
      weekday: "long",
      month: "long",
      day: "numeric",
    };
    shippingText.textContent = deliveryDate.toLocaleDateString(
      "fr-FR",
      options
    );
  }
});
